import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { Onboarding } from "@/pages/team/Onboarding";

/**
 * Onboarding ist reine Team-Arbeit: Ein Mitarbeiter führt das
 * Kick-off-Gespräch und erfasst die Antworten — der Kunde füllt hier nichts
 * selbst aus, deshalb gibt es keine Kunden-Fassung dieser Seite.
 *
 * `?kundeId=` kommt vom „Onboarding starten" direkt nach dem Anlegen eines
 * Kunden und belegt den Start-Assistenten mit genau diesem Kunden vor;
 * `?unterlagen=1` sagt dazu, dass die Anfrage Unterlagen hatte (Eingang
 * unter /anfragen seit dem 11.09.2026) — die KI liest sie dann vor.
 */
const suchSchema = z.object({
	kundeId: z.string().optional(),
	unterlagen: z.string().optional(),
});

export const Route = createFileRoute("/_angemeldet/_mitarbeiter/onboarding")({
	validateSearch: suchSchema,
	component: OnboardingSeite,
});

function OnboardingSeite() {
	const { kundeId, unterlagen } = Route.useSearch();
	return <Onboarding vorbelegteKundeId={kundeId} mitUnterlagen={unterlagen === "1"} />;
}
